<template lang="pug">
	.app
		ProjectActionsCreate
		ProjectFolderActionsCreate
		ProjectActionsShowFolders
		ProjectActionsClone
		ProjectActionsRename
		ProjectFolderActionsRename
		ProjectActionsDelete
		ProjectFolderActionsDelete
		UploadAmazonS3
		UploadAmazonS3Multiple
		UploadServer
		UploadTest
		DownloadVideo
		MonitoringLog
		AssetPreviewMini
		ItemsDropdown
		SectionActionsCreate
		SectionActionsRemove
		AssetVideoCreate
		SettingsEditAirbrakerFilteredIps
		DisplayText
		SettingsConflictDetectionToolViewTag
		SectionsChangesHistory
		ActionsDomain
		ActionsCreateNewWebsiteDomain
		ActionsRemoveWebsiteDomain
		ErrorNotification
		JsonEditor
		CssEditor
		header.app-header.navbar(v-if="Layout.layout === 'dashboard'")
			PublisherLogo
			.demo-access(v-if="User.loaded && (!User.User || !User.User.haveAccess)") The users from venatusmedia.com domain only can access this application
			.right-controls(v-if="Layout.layout === 'dashboard'")
				SettingsToggler(v-if="User.User && User.User.haveAccess")
				AccountButton
		.app-body
			TemplateList(v-if="Layout.layout === 'dashboard' && User.User && User.User.haveAccess")
			ProjectList(v-if="Layout.layout === 'dashboard' && User.User && User.User.haveAccess")
			main.main(:style="{'margin-left': `${Layout.layout === 'dashboard' ? (Layout.templatesPlaneWidth + Layout.projectsPlaneWidth) : 0}px`, 'margin-right': `${Layout.asideOpened ? Layout.asideSize : 0}px`}")
				.container-fluid
					Preview(v-if="User.User && User.User.haveAccess")
					.no-access(v-if="User.User && !User.User.haveAccess")
			SettingsPlane(fixed)
				SettingsContent
</template>

<script>
	import Screen 							from './../../mixins/screen'

	import Preview 							from './../../components/Preview/Preview'
	import TemplateList 					from './../../components/Template/TemplateList'
	import ProjectList 						from './../../components/Project/ProjectList'
	import ProjectActionsCreate 			from './../../components/Project/ProjectActionsCreate'
	import ProjectFolderActionsCreate 		from './../../components/Project/ProjectFolderActionsCreate'
	import ProjectActionsShowFolders		from './../../components/Project/ProjectActionsShowFolders'
	import ProjectActionsClone 				from './../../components/Project/ProjectActionsClone'
	import ProjectActionsRename				from './../../components/Project/ProjectActionsRename'
	import ProjectFolderActionsRename		from './../../components/Project/ProjectFolderActionsRename'
	import ProjectActionsDelete				from './../../components/Project/ProjectActionsDelete'
	import ProjectFolderActionsDelete		from './../../components/Project/ProjectFolderActionsDelete'

	import AssetPreviewMini					from './../../components/Dashboard/AssetPreviewMini'
	import ItemsDropdown					from './../../components/Dashboard/ItemsDropdown'

	import UploadAmazonS3					from './../../components/Dashboard/UploadAmazonS3'
	import UploadAmazonS3Multiple			from './UploadAmazonS3Multiple'
	import UploadServer						from './../../components/Dashboard/UploadServer'
	import UploadTest						from './../../components/Dashboard/UploadTest'

	import DownloadVideo 					from "@/components/Dashboard/DownloadVideo";


	import MonitoringLog					from './../../components/Monitoring/MonitoringLog'

	import SettingsPlane 					from './../../components/Settings/SettingsPlane'
	import SettingsContent 					from './../../components/Settings/SettingsContent'

	import PublisherLogo 					from './../../components/Header/PublisherLogo'
	import AccountButton 					from './../../components/Header/AccountButton'
	import SettingsToggler 					from './../../components/Header/SettingsToggler'

	import SectionActionsCreate				from "../Settings/SectionActionsCreate";
	import SectionActionsRemove		 		from "../Settings/SectionActionsRemove";

	import SettingsEditAirbrakerFilteredIps from "../Settings/SettingsEditAirbrakerFilteredIps";
	import SettingsConflictDetectionToolViewTag from "../Settings/SettingsConflictDetectionToolViewTag";
	import SectionsChangesHistory			from "../Settings/SectionsChangesHistory";

	import DisplayText 						from "../Dashboard/DisplayText";


	import AssetVideoCreate			 		from "../Settings/AssetVideoCreate";

	import ActionsCreateNewWebsiteDomain	from "../Dashboard/ActionsCreateNewWebsiteDomain";
	import ActionsRemoveWebsiteDomain 		from "../Dashboard/ActionsRemoveWebsiteDomain";
	import ActionsDomain 					from "../Dashboard/ActionsDomain";

	import ErrorNotification 				from "../Dashboard/ErrorNotification";

	import JsonEditor 						from "../Dashboard/JsonEditor";
	import CssEditor 						from "../Dashboard/CssEditor";

	import { User } 						from './../../services/User';
	import { Layout } 						from './../../services/Layout';

	export default {
		name: 'Dashboard',
		mixins: [Screen],
		screen: {
			updateOn: ["Current User Changed", "Layout Changed", "Aside State Changed"]
		},
		components: {
			DownloadVideo,
			DisplayText,
			PublisherLogo,
			AccountButton,
			TemplateList,
			ProjectList,
			ProjectActionsCreate,
			ProjectFolderActionsCreate,
			ProjectActionsShowFolders,
			ProjectActionsClone,
			ProjectActionsRename,
			ProjectFolderActionsRename,
			ProjectActionsDelete,
			ProjectFolderActionsDelete,
			AssetPreviewMini,
			ItemsDropdown,
			UploadAmazonS3,
			UploadAmazonS3Multiple,
			UploadServer,
			UploadTest,
			MonitoringLog,
			Preview,
			SettingsToggler,
			SettingsPlane,
			SettingsContent,
			SectionActionsCreate,
			SectionActionsRemove,
			SettingsEditAirbrakerFilteredIps,
			SettingsConflictDetectionToolViewTag,
			SectionsChangesHistory,
			AssetVideoCreate,
			ActionsDomain,
			ActionsCreateNewWebsiteDomain,
			ActionsRemoveWebsiteDomain,
			ErrorNotification,
			JsonEditor,
			CssEditor
		},
		data() {
			this.User = User;
			this.Layout = Layout;

			return {
				showed: true
			};
		},
		methods: {
			collectData() {


			}
		}
	}
</script>

<style lang="sass">

	.app

		.custom-range
			height: 0 !important
			cursor: pointer

		.app-body
			margin-top: 0

			.main
				position: relative

				.container-fluid
					padding-top: 30px

		header.app-header.navbar
			position: relative
			flex-direction: row
			height: 55px
			padding: 0
			margin: 0
			background-color: #3a4149
			border-bottom: 1px solid #23282c
			flex: 0 0 55px

			.navbar-brand
				position: static
				top: auto
				left: auto
				margin-left: 0

			.download-button
				margin-left: auto

			.settings-button
				margin-left: 0

			.right-controls
				display: flex

			.demo-access
				color: #f86c6b

	html:not([dir="rtl"]) .aside-menu-show.aside-menu-fixed .main,
	html:not([dir="rtl"]) .aside-menu-show.aside-menu-fixed .app-footer
		margin-right: 390px

</style>
